module.exports = "https://coursera_assets.s3.amazonaws.com/images/bb27e094f0d3c8a047b9463fedae89be.png";